/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { css, StyleSheet } from 'aphrodite';
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { colors, LoadingSpinner, mixins } from '@blend/consumer-components';

import { mediaBreakpoints } from '../../../common/responsive';

import './PdfViewer.scss';
import { DocumentStatusTag } from '../DocumentStatusTag/DocumentStatusTag';

export namespace DocumentWrapper {
  export interface Props {
    fileName: string;
    pdfUrl: string;
    width: number;
  }
}

const styles = StyleSheet.create({
  document: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    margins: mixins.margin(8),
  },
  page: {
    ...mixins.margin(8, 'auto'),
    [mediaBreakpoints.mobile]: {
      ...mixins.margin(16, 8),
    },
    ':last-child': {
      marginTop: 0,
    },
  },
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  documentNameWrapper: {
    textAlign: 'left',
    ...mixins.padding(8),
  },
});

export const DocumentWrapper: React.FC<DocumentWrapper.Props> = ({ fileName, pdfUrl, width }) => {
  const [numPages, setNumPages] = useState(1);

  function onDocumentLoadSuccess(pdf: pdfjs.PDFDocumentProxy) {
    setNumPages(pdf.numPages);
  }

  function renderLoadingSpinner() {
    return (
      <div className={css(styles.loadingWrapper)}>
        <LoadingSpinner size={'sm'} color={colors.catalyst} />
      </div>
    );
  }

  return (
    <div>
      <div className={css(styles.documentNameWrapper)}>
        {fileName}
        <DocumentStatusTag indicatorType="info" indicatorText="UNDER REVIEW" />
      </div>
      <Document
        className={css(styles.document)}
        file={pdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={renderLoadingSpinner}
      >
        {Array.from(new Array(numPages), (_, i) => (
          <Page key={`page_${i + 1}`} width={width - 20} className={css(styles.page)} pageNumber={i + 1} />
        ))}
      </Document>
    </div>
  );
};
